






















































import { defineComponent, computed, ComponentInternalInstance, getCurrentInstance, ref } from '@vue/composition-api';
import { SearchIcon } from 'tdesign-icons-vue';

// 引入组件
import UserAvatar from '@/renderer/components/user/components/userAvatar.vue';
import Menu, { MenuHandler } from '@/renderer/views/desktop/headbar/components/MobileGeneralHeader/Menu.vue';
import TeamMenu from '@/renderer/components/TeamTree/index.vue';

// 引入 compositions
import rendererHandler from '@/renderer/views/desktop/headbar/composition/generalRendererHandler';
import baseHeadbarHandler from '@/renderer/views/desktop/headbar/composition/baseHeadbarHandler';
import searchHandler from '@/renderer/scripts/composition/searchHandler';

// 引入工具类
import user from '@/renderer/scripts/utils/user';
import { IS_BROWSER_IN_MOBILE } from '@/common/constant/platform';
import { SMH } from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import storage from '@/renderer/scripts/utils/storage';
import { httpUrl } from '@/renderer/scripts/http';

export default defineComponent({
  name: 'MobileGeneralMenu',
  components: {
    SearchIcon,
    UserAvatar,
    Menu,
    TeamMenu,
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const searchPreviousRoute = computed(() => store.getters.searchPreviousRoute);
    const { envHelp } = baseHeadbarHandler();
    const { orgLogo, methods: headBarMethods } = rendererHandler();
    const { showController, methods: menuMethods } = MenuHandler();
    const isSearch = computed(() => vm.$route.name === 'search');
    const { methods: searchMethods } = searchHandler();
    const defaultTeamPath = ref<string[] | boolean>(false);
    const rendererBar = computed(() => {
      const isMobile = IS_BROWSER_IN_MOBILE;
      return {
        orgLogo: orgLogo.value && isMobile,
        envHelp: !!envHelp.value,
      };
    });
    const showLogo = computed(() => !isSearch.value && (showController.menu || showController.subMenu === ''));
    const initUser = async () => {
      if (!vm.$store.getters.isLogined) return;
      const { organizationId } = user.getUserInfo();
      // 查询是否有个人空间路由
      store.dispatch('checkPersonalSpace');
      await store.dispatch('getUserBaseInfo');
      store.dispatch('GetOrgInfo', organizationId);
      // 管理员权限查询企业配额
      // if (store.getters.userBaseInfo.role !== 'user') {
      //   store.dispatch('GetOrgSpace');
      // }
    };

    initUser();
    const methods = {
      onDispatchRouter(item: RouteItem) {
        if (['teamSpace'].includes(item.route)) {
          // 协作空间、企业空间额外处理
          menuMethods.openMenu(item.route);
        } else {
          headBarMethods.onOperateEventProxy('changeRoute', {
            route: item,
          });
          menuMethods.closeMenu();
        }
      },
      getDefaultTeamPath() {
        if (vm.$route.name === 'teamSpace') {
          const teamPathInfo = storage.get(storage.StoreKey.TEAM_PATH) as TeamPathStorageInfo;
          if (teamPathInfo) {
            const { path, orgId } = teamPathInfo;
            if (orgId && vm.$store.getters.orgId !== orgId) {
              defaultTeamPath.value = true;
              return;
            }
            defaultTeamPath.value = path;
          } else {
            defaultTeamPath.value = true;
          }
        } else {
          defaultTeamPath.value = false;
        }
      },
      onOpenMenu() {
        const routeName = vm.$route.name as string;
        if (['teamSpace'].includes(routeName)) {
          methods.getDefaultTeamPath();
          menuMethods.openMenu(routeName);
        } else {
          menuMethods.openMenu();
        }
      },
      onSelectTeam(node: { data: SMH.TeamTreeNode; init: boolean }) {
        if (!node) return;
        if (node.init) return;
        const selectedTeam = node.data;
        const query = {
          teamPath: [...(selectedTeam.path || [])].join('/'),
          spaceId: selectedTeam.spaceId,
          teamId: `${selectedTeam.id}`,
        };
        const type = vm.$route.name === 'teamSpace' ? 'replace' : 'push';
        dispatchRouter(
          {
            name: 'teamSpace',
            query,
          },
          type,
        );
        storage.set(storage.StoreKey.TEAM_PATH, {
          path: [...(selectedTeam.path || [])],
          spaceId: selectedTeam.spaceId,
          id: selectedTeam.id,
          orgId: vm.$store.getters.orgId,
        });
        menuMethods.closeMenu();
      },
      // 跳转全局搜索
      onGlobalSearch() {
        menuMethods.closeMenu();
        searchMethods.openSearch({
          keyword: '',
          scope: 'global',
        });
      },
    };
    return {
      rendererBar,
      envHelp,
      orgLogo,
      defaulLogo: httpUrl.staticCDNURLMap.productLogoUrl,
      defaultTeamPath,
      isSearch,
      searchMethods,
      showController,
      showLogo,
      ...headBarMethods,
      ...menuMethods,
      ...methods,
    };
  },
});
